'use strict';

const { registerSteerInboundListeners } = require('public/js/lib/steer-inbound');

registerSteerInboundListeners();
